import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import $ from 'jquery';

// 导出日报
export default {
  install(Vue, options) {
    Vue.prototype.downloadPage = function (id, zyknum, zykname) {
      // Vue.prototype.downloadPage = function(id, pdfFileName, hide) {
      // // this.$message.loading('正在下载', 2.5)
      // var ele = document.getElementById(id)
      // pdfFileName = pdfFileName || 'pdf'
      // window.pageYoffset = 0 // 滚动置顶
      // document.documentElement.scrollTop = 0
      // document.body.scrollTop = 0
      //     // ele.style.fontSize = '18px'
      //     // ele.style.padding='30px';
      //     // let scale = window.devicePixelRatio * 2
      // html2canvas(ele, {
      //     // dpi: 300,
      //     // dpi: window.devicePixelRatio * 4, // 将分辨率提高到特定的DPI 提高四倍
      //     // scale: 4, // 按比例增加分辨率
      //     // logging: false,
      //     // scale:scale,
      //     useCORS: true, // 允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
      //     // allowTaint: false,
      //     // height: ele.offsetHeight,
      //     // width: ele.offsetWidth,
      //     windowWidth: document.body.scrollWidth,
      //     windowHeight: document.body.scrollHeight
      //         // backgroundColor: '#fff'
      // }).then(canvas => {
      //     // const _this = this
      //     // 未生成pdf的html页面高度
      //     var leftHeight = canvas.height * canvas.width / 1343
      //         // var a4Width = 555.28 // 原A4宽 592 因为要设置边距 20 ,这里要减掉 40
      //         // var a4Height = 801.89 // 原A4高   841 因为要设置边距 20 ,这里要减掉 40
      //     var a4Width = 495.28 // 原A4宽 592 因为要设置边距 50 ,这里要减掉 100
      //     var a4Height = 741.89 // 原A4高   841 因为要设置边距 50 ,这里要减掉 100

      //     // 一页pdf显示html页面生成的canvas高度;
      //     var a4HeightRef = Math.floor(canvas.width / a4Width * a4Height)
      //     console.log("一页高度", a4HeightRef, leftHeight, canvas.height, canvas.width);

      //     // pdf页面偏移
      //     var position = 0

      //     var pageData = canvas.toDataURL('image/jpeg', 1.0)

      //     var pdf = new JsPDF('x', 'pt', 'a4')
      //         // let printIndex = 1
      //     const canvas1 = document.createElement('canvas')
      //     let height
      //     pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen')

      //     function createImpl(canvas) {
      //         if (leftHeight > 0) {
      //             // printIndex++
      //             var checkCount = 0
      //             if (leftHeight > a4HeightRef) {
      //                 var i = position + a4HeightRef
      //                 for (i = position + a4HeightRef; i >= position; i--) {
      //                     var isWrite = true
      //                     for (var j = 0; j < canvas.width; j++) {
      //                         var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data

      //                         if (c[0] !== 0xff || c[1] !== 0xff || c[2] !== 0xff) {
      //                             isWrite = false
      //                             break
      //                         }
      //                     }
      //                     if (isWrite) {
      //                         checkCount++
      //                         if (checkCount >= 10) {
      //                             break
      //                         }
      //                     } else {
      //                         checkCount = 0
      //                     }
      //                 }
      //                 height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef)
      //                 if (height <= 0) {
      //                     height = a4HeightRef
      //                 }
      //             } else {
      //                 height = leftHeight
      //             }

      //             canvas1.width = canvas.width
      //             canvas1.height = height

      //             // console.log(index, 'height:', height, 'pos', position);

      //             var ctx = canvas1.getContext('2d')
      //             ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height) // 边距这里设置0，不然又黑边

      //             // var pageHeight = Math.round(a4Width / canvas.width * height)
      //             // pdf.setPageSize(null, pageHeight)
      //             if (position !== 0) {
      //                 pdf.addPage()
      //             }
      //             // 设置 50px 边距
      //             pdf.addImage(canvas1.toDataURL('image/jpeg', 1.0), 'JPEG', 50, 20, a4Width, a4Width / canvas1.width * height)
      //             pdf.text(150, 285, 'page ' + index); //print number bottom right
      //             leftHeight -= height
      //             position += height
      //             if (leftHeight > 0) {
      //                 // 添加全屏水印
      //                 /* const base64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAArCAYAAADIWo5HAAACLUlEQVR42u2Zy2sCMRDGV9tbtVJKrQ/0JBWLvbgsaOttQQqreO5R6GHP/v+HZiEDQ9i8k33YDHyXbcxufpN8maRRFCJEiBAhQoTgRIfoh+hKNBe0G9I2GVG3om9bEl2I9rcIoE/77Cq8Myd6sn2ZSBgAr80YARhI+gOwCdGW6EB/d6R9XDUGFrsAf2Fe7Fswk1JBmzMd1DNKgI2EywQyUKYjkxFeOwwxkwgAvBJNqEa0DzaTHcn3qWrXdA/ocQD8m11ABUDfQF0fpujjI2QAeoZetdYdfOzB9HgGNEF6owM8Ec3Q8wEDgP07T6ktgNyB8YgAqGZ0b+gRsS2AtQP/iAUAHlAdsEW7TY6eFVrVNQN8A2AjlZho5R5wYjJhoqMiADy4DFWLPJMcKBhv3AYThFi4yJyrAAAfDrY/1SVQVhLDOWDowIwzSQ1TqwfA1P5CU3yJlsPY8fmjcTMgptmeIwB3aFbsLCvM2BRAFR4AZXYxuEdmn38hmjoosY0B5IonxLNhIYTNby0odMoAJJL1/k10bwpgQztZKaxb2YXFRnAUhexDHzoAUsGxu3j+awNA5+RmcxW1UCx1eQB4SyI1AaBrbiMEYGrwexgYBlgrgGtU/ZUY3AlGhgByTvV5MQGgW1SomqBOUWLiATy1wgNsABQz51PzWHxTALzWAW0F0EM+MKPmnLj6x0lbAPDuC5zfNPsCcChZ25DZd4VBJCW7wrRp1+whQoQIESJEg+IPRa38G55TPkQAAAAASUVORK5CYII='
      //                 for (let i=0;i<6;i++) {
      //                   for (let j=0;j<5;j++) {
      //                     const  left = (j * 120) + 20
      //                     pdf.addImage(base64,'JPEG', left, i*150, 20, 30); // 关掉水印
      //                   }
      //                 } */
      //                 setTimeout(createImpl, 500, canvas)
      //             } else {
      //                 pdf.save(pdfFileName + '.pdf')
      //                 setTimeout(hide, 500)
      //                     // this.$message.success('下载完成', 2.5)
      //             }
      //         }
      //     }

      //     // 当内容未超过pdf一页显示的范围，无需分页
      //     if (leftHeight < a4HeightRef) {
      //         pdf.addImage(pageData, 'JPEG', 50, 20, a4Width, a4Width / canvas.width * leftHeight)
      //         pdf.save(pdfFileName + '.pdf')
      //     } else {
      //         try {
      //             pdf.deletePage(0)
      //             setTimeout(createImpl, 500, canvas)
      //         } catch (err) {
      //             console.log(err)
      //         }
      //     }
      // })

      const ele = document.getElementById(id);
      html2canvas(ele, {
        // dpi: 300,
        // dpi: window.devicePixelRatio * 4, // 将分辨率提高到特定的DPI 提高四倍
        scale: 2, // 按比例增加分辨率
        background: '#FFFFFF',
        useCORS: true, // 允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
        // allowTaint: false,
        // height: ele.offsetHeight,
        // width: ele.offsetWidth,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight
      }).then((canvas) => {
        // 未生成pdf的html页面高度
        let leftHeight = canvas.height;
        const leftWidth = canvas.width;
        const a4Width = 190;
        const a4Height = 277; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        // 一页pdf显示html页面生成的canvas高度;
        const a4HeightRef = Math.floor(canvas.width / a4Width * a4Height);

        // pdf页面偏移
        let position = 0;
        const pageData = canvas.toDataURL('image/jpeg', 1.0);

        // 三个参数，第一个方向，第二个单位，第三个尺寸格式
        const pdf = new JsPDF('p', 'mm', 'a4'); // A4纸，纵向
        let index = 1;
        const canvas1 = document.createElement('canvas');
        let height;
        pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');

        const pdfName = `${zyknum}_${zykname}_` + '月报';

        function createImpl(canvas) {
          if (leftHeight > 0) {
            index++;

            let checkCount = 0;
            if (leftHeight > a4HeightRef) {
              let i = position + a4HeightRef;
              for (i = position + a4HeightRef; i >= position; i--) {
                let isWrite = true;
                for (let j = 0; j < canvas.width; j++) {
                  const c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
                  if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                    isWrite = false;
                    break;
                  }
                }
                if (isWrite) {
                  checkCount++;
                  if (checkCount >= 10) {
                    break;
                  }
                } else {
                  checkCount = 0;
                }
              }
              height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
              if (height <= 0) {
                height = a4HeightRef;
              }
            } else {
              height = leftHeight;
            }

            canvas1.width = canvas.width;
            canvas1.height = height;

            // console.log(index, 'height:', height, 'pos', position);

            const ctx = canvas1.getContext('2d');
            ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);
            const pageHeight = Math.round(a4Width / canvas.width * height);
            // pdf.setPageSize(null, pageHeight)
            if (position != 0) {
              pdf.addPage();
            }
            // addImage后两个参数控制添加图片的尺寸，此处将页面高度按照a4纸宽高比列进行压缩
            pdf.addImage(canvas1.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4Width, a4Width / canvas1.width * height);
            leftHeight -= height;
            position += height;
            if (leftHeight > 0) {
              setTimeout(createImpl, 500, canvas);
            } else {
              pdf.save(`${pdfName}.pdf`);
            }
          }
        }

        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < a4HeightRef) {
          pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, a4Width / canvas.width * leftHeight);
          pdf.save(`${pdfName}.pdf`);
        } else {
          try {
            pdf.deletePage(0);
            setTimeout(createImpl, 500, canvas);
          } catch (err) {
            // console.log(err);
          }
        }
      });
    };
  },
};
